/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { useState } from 'react';
import { Container, Row, Button, Accordion } from 'react-bootstrap';
import { PlusIcon } from '@heroicons/react/solid';
import withReactContent from 'sweetalert2-react-content';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import {
    KanbanCard,
    KanbanList,
    KanbanCreateModal,
    KanbanCopyModal,
    KanbanMoveModal,
    KanbanEditModal,
} from './components';
import { createCard } from './data';
import Swal from 'sweetalert2';

export interface IKanbanWidgetProps {
    kanbanList: any[];
    cardType?: string;
    confirmButtonLabel?: string;
    totalSections?: number;
    attributeForm?: ITweetyWidgetProps;
    attributeTypeValue?: any[];
    labelColor?: string;
    cardTitleField?: string;
    fontScale?: number;
    hiddenFields?: string[];
    onKanbanConfirm?(kanbanLists: any): void;
    onDynamicFieldChange?(id: string, payload: any): void;
    _deletemanagerial?(id: any, payload: any): any;
    cityCall?(id: any, payload: any): any;
}

const SwalWithBootstrapButtons = withReactContent(
    Swal.mixin({
        customClass: {
            confirmButton: 'btn btn-primary me-3',
            cancelButton: 'btn btn-gray',
        },
        buttonsStyling: false,
    })
);

export const DynamicFieldsKanbanWidget = ({
    kanbanList,
    cardType,
    confirmButtonLabel,
    onKanbanConfirm,
    attributeTypeValue,
    attributeForm,
    labelColor,
    hiddenFields,
    fontScale,
    cardTitleField,
    totalSections,
    onDynamicFieldChange,
    _deletemanagerial,
    cityCall,
}: IKanbanWidgetProps) => {
    // console.log("jeyaramupdatedkanban->return->hints->",cardType,cardTitleField,attributeTypeValue);
    const [form, setform] = useState(attributeForm);
    console.log('hi->', attributeForm, form);

    const [kanbanLists, setKanbanLists] = useState(kanbanList);
    const [showCreateCardModal, setShowCreateCardModal] = useState(false);
    const createCardDefaultProps = { listId: kanbanLists[0].id, cardIndex: 0 };
    const [cardToEdit, setCardToEdit] = useState<any>({
        show: false,
        cardId: null,
    });
    const [cardToCopy, setCardToCopy] = useState<any>(null);
    const [cardToMove, setCardToMove] = useState<any>(null);
    const lCardType = cardType?.toLowerCase();
    const pCardType = `${lCardType}s`;

    const [createCardProps, setCreateCardProps] = useState(
        createCardDefaultProps
    );

    const toggleCreateCardModal = (props = {}) => {
        setCreateCardProps({ ...createCardDefaultProps, ...props });
        setShowCreateCardModal(!showCreateCardModal);
    };

    const handleCopyCard = (card: any = {}) => {
        const { listId, title, attributeType, isRequired } = card;
        const listsUpdated = createCardInListAtIndex({
            listId,
            title,
            attributeType,
            isRequired,
        });

        setCardToCopy(null);
        setKanbanLists(listsUpdated);
    };

    const handleCardChange = (props: any) => {
        const { listId, cardId, ...otherProps } = props;
        console.log(props, 'ho->');
        const listsUpdated = kanbanLists.map((l) => {
            const cards = l.cards?.map((c: any) =>
                c.id === cardToEdit?.cardId ? { ...c, ...otherProps } : c
            );
            return { ...l, cards };
        });

        // if (cardToEdit) {
        //   setCardToEdit({ ...cardToEdit, ...otherProps });
        // }
        setCardToEdit(null);
        setKanbanLists(listsUpdated);
        onKanbanConfirm && onKanbanConfirm(listsUpdated);
    };

    const handleListTitleChange = ({ id, title }: any) => {
        const listsUpdated = kanbanLists.map((l) =>
            l.id === id ? { ...l, title } : l
        );
        setKanbanLists(listsUpdated);
    };

    const removeCardsFromList = (cards: any) => {
        // console.log("jeyaramupdatedkanban->return->cards",cards);
        const cardsGroupedByListId = cards.reduce((acc: any, card: any) => {
            const { listId, cardId } = card;

            if (!acc[listId]) acc[listId] = [cardId];
            else acc[listId].push(cardId);
            console.log('jramupdatedkanban->return', acc);
            return acc;
        }, {});
        console.log('jeyaramupdatedkanban->return->before', kanbanLists);
        let listsUpdated = [];
        if (
            cardType === 'Director' ||
            cardType === 'Subsidiary' ||
            cardType === 'Branch'
        ) {
            let enumlist = {
                Director: 'directors',
                Subsidiary: 'subsidiaries',
                Branch: 'branches',
            };
            listsUpdated = kanbanLists.map((l, kee: any) => {
                const cardsToDelete = cardsGroupedByListId[l.id];
                if (!cardsToDelete) return l;
                const cardsUpdatedfirst = l.cards.map((c: any, ket: any) => {
                    if (cardsToDelete.includes(c.id)) {
                        console.log('finalcheck->', cardType, {
                            email: c.email,
                            name: c.name,
                            operation: 'REMOVE',
                        });

                        _deletemanagerial(enumlist[cardType], {
                            email: c.email,
                            name: c.name,
                            operation: 'REMOVE',
                        });
                        return c;
                        // return {email:c.email,operation : "delete"};
                    } else {
                        return c;
                    }
                });
                const cardsUpdated = l.cards.filter(
                    (c: any) => !cardsToDelete.includes(c.id)
                );
                console.log('jeyaramupdatedkanban->return->after', {
                    ...l,
                    cards: cardsUpdated,
                });
                return { ...l, cards: cardsUpdated };
            });
        } else {
            listsUpdated = kanbanLists.map((l) => {
                const cardsToDelete = cardsGroupedByListId[l.id];
                if (!cardsToDelete) return l;

                const cardsUpdated = l.cards.filter(
                    (c: any) => !cardsToDelete.includes(c.id)
                );
                console.log('jeyaramupdatedkanban->return->after', {
                    ...l,
                    cards: cardsUpdated,
                });
                return { ...l, cards: cardsUpdated };
            });
        }
        return listsUpdated;
    };

    const handleKanbanConfirm = () => {
        console.log('kanbanList =>', kanbanList);
        if (kanbanLists && kanbanLists[0]?.cards?.length) {
            onKanbanConfirm && onKanbanConfirm(kanbanLists);
        } else {
            SwalWithBootstrapButtons.fire({
                icon: 'error',
                title: `No ${cardType} found`,
                text: `Please add at least one attribute to proceed`,
                showCancelButton: false,
                confirmButtonText: 'OK',
            });
        }
    };

    const handleCardsDelete = async (cards: any = []) => {
        console.log('jramupdatedkanban->', cards);
        const listsUpdated = removeCardsFromList(cards);
        setKanbanLists(listsUpdated);
        onKanbanConfirm && onKanbanConfirm(listsUpdated);
    };

    const handleListDelete = async (listId: any) => {
        const result = await SwalWithBootstrapButtons.fire({
            icon: 'error',
            title: 'Confirm deletion',
            text: 'Are you sure do you want to delete this list?',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'Cancel',
        });

        if (result.isConfirmed) {
            const listsUpdated = kanbanLists.filter((l) => l.id !== listId);
            setKanbanLists(listsUpdated);

            await SwalWithBootstrapButtons.fire(
                'Deleted',
                'The list has been deleted.',
                'success'
            );
        }
    };

    const createCardInListAtIndex = (props: any) => {
        const { listId, cardIndex, ...otherProps } = props;

        const listsUpdated = kanbanLists.map((l) => {
            if (listId !== l.id) return l;

            const newCard = createCard(otherProps);
            if (l.cards && Array.isArray(l.cards)) {
                l.cards.splice(cardIndex, 0, newCard);
            } else {
                l.cards = [];
                l.cards.splice(cardIndex, 0, newCard);
            }
            return l;
        });
        return listsUpdated;
    };

    const handleCreateCard = (props = {}) => {
        const listsUpdated = createCardInListAtIndex({
            ...props,
        });
        console.log('ho->', props, listsUpdated);
        toggleCreateCardModal();
        setKanbanLists(listsUpdated);
        onKanbanConfirm && onKanbanConfirm(listsUpdated);
    };

    const reorderCards = (cards = [], startIndex: any, endIndex: any) => {
        const [cardRemoved] = cards.splice(startIndex, 1);
        cards.splice(endIndex, 0, cardRemoved);

        return cards;
    };

    const moveCardFromList = (
        sList: any,
        dList: any,
        sIndex: any,
        dIndex: any
    ) => {
        const sCards = [...sList.cards];
        const dCards = [...dList.cards];

        const [cardRemoved] = sCards.splice(sIndex, 1);
        dCards.splice(dIndex, 0, cardRemoved);

        return [
            { ...sList, cards: sCards },
            { ...dList, cards: dCards },
        ];
    };

    const handleDragEnd = (dragResult: any) => {
        const { source, destination } = dragResult;

        //  dropped outside the list
        if (!destination) {
            return;
        }

        const { droppableId: sListId, index: sCardIndex } = source;
        const { droppableId: dListId, index: dCardIndex } = destination;

        const sList = kanbanLists.find((l) => l.id === sListId);
        const dList = kanbanLists.find((l) => l.id === dListId);

        if (sListId === dListId) {
            // reorder cards in the list only if card's index changes
            if (sCardIndex !== dCardIndex) {
                const sCardsUpdated = reorderCards(
                    sList.cards,
                    sCardIndex,
                    dCardIndex
                );
                const listsUpdated = kanbanLists.map((l) =>
                    l.id === sListId ? { ...l, cards: sCardsUpdated } : l
                );
                setKanbanLists(listsUpdated);
            }
        } else {
            const [sListUpdated, dListUpdated] = moveCardFromList(
                sList,
                dList,
                sCardIndex,
                dCardIndex
            );
            const listsUpdated = kanbanLists.map((l) =>
                l.id === sListId
                    ? sListUpdated
                    : l.id === dListId
                    ? dListUpdated
                    : l
            );
            setKanbanLists(listsUpdated);
        }

        if (cardToMove) {
            setCardToMove(null);
        }
    };
    const getCardStyle = (style: any, snapshot: any) => {
        const isJustDragging = snapshot.isDragging && !snapshot.isDropAnimating;

        if (!isJustDragging) {
            return style;
        }

        return {
            ...style,
            transform: `${style.transform || ''} rotate(6deg)`,
        };
    };

    const _renderKanbanCreateModalIf = () => {
        if (showCreateCardModal) {
            return (
                <KanbanCreateModal
                    fontScale={fontScale}
                    show={showCreateCardModal}
                    onHide={toggleCreateCardModal}
                    onSubmit={handleCreateCard}
                    attributeTypeValue={attributeTypeValue}
                    cardType={cardType}
                    attributeForm={attributeForm}
                    modalTitle={attributeForm?.modalTitle}
                    onDynamicFieldChange={onDynamicFieldChange}
                />
            );
        }
    };

    const _renderKanbanCopyModalIf = () => {
        if (cardToCopy) {
            return (
                <KanbanCopyModal
                    cardType={cardType}
                    show={true}
                    {...cardToCopy}
                    lists={kanbanLists}
                    onHide={() => setCardToCopy(null)}
                    onSubmit={handleCopyCard}
                />
            );
        }
    };

    const _renderKanbanMoveModalIf = () => {
        if (cardToMove) {
            return (
                <KanbanMoveModal
                    show={true}
                    {...cardToMove}
                    lists={kanbanLists}
                    onHide={() => setCardToMove(null)}
                    onSubmit={handleDragEnd}
                />
            );
        }
    };

    const _renderKanbanEditModalIf = () => {
        console.log('jo->', kanbanLists[0]?.cards, cardToEdit);
        if (cardToEdit?.show) {
            return (
                <KanbanEditModal
                    show={true}
                    {...cardToEdit}
                    fontScale={fontScale}
                    cardType={cardType}
                    cityCall={cityCall}
                    _deletemanagerial={_deletemanagerial}
                    onHide={() => setCardToEdit(null)}
                    onChange={handleCardChange}
                    attributeTypeValue={attributeTypeValue}
                    attributeForm={attributeForm}
                    onDynamicFieldChange={onDynamicFieldChange}
                    modalTitle={attributeForm?.editTitle}
                    initialData={kanbanLists[0]?.cards[cardToEdit?.index]}
                />
            );
        }
    };
    console.log('lmno->', kanbanLists);
    return (
        <>
            {_renderKanbanCreateModalIf()}
            {_renderKanbanCopyModalIf()}
            {_renderKanbanMoveModalIf()}
            {_renderKanbanEditModalIf()}
            <Container
                fluid
                className="kanban-container shadow py-4 px-0 overflow-hidden"
            >
                <Row className="d-flex flex-nowrap align-content-start align-items-start justify-content-start">
                    {/* <DragDropContext onDragEnd={handleDragEnd}> */}
                    {kanbanLists.map((list, ind) => {
                        const { id: listId, cards } = list;

                        console.log(
                            'klo->',
                            totalSections,
                            totalSections !== undefined,
                            cards.length,
                            totalSections,
                            totalSections !== undefined &&
                                cards.length >= totalSections
                        );
                        // return (
                        //     <Droppable
                        //         index={ind}
                        //         droppableId={`${listId}`}
                        //         key={`kanban-list-${listId}`}
                        //     >
                        //         {(provided) => {
                        //             const {
                        //                 innerRef: listRef,
                        //                 placeholder,
                        //                 droppableProps,
                        //             } = provided;

                        return (
                            <KanbanList
                                {...list}
                                // listRef={listRef}
                                // extraProps={droppableProps}
                            >
                                <Accordion defaultActiveKey={0}>
                                    {Array.isArray(cards) &&
                                        cards?.map((card: any, index: any) => {
                                            const { id: cardId } = card;
                                            {
                                                console.log(
                                                    cards,
                                                    cards.length - 1,
                                                    index,
                                                    'ko->'
                                                );
                                            }

                                            return (
                                                <Accordion.Item
                                                    eventKey={index}
                                                    className=""
                                                >
                                                    {/* <Draggable
                                                            index={index}
                                                            draggableId={`${cardId}`}
                                                            key={`kanban-card-${cardId}`}
                                                        >
                                                            {(
                                                                provided,
                                                                snapshot
                                                            ) => {
                                                                const {
                                                                    innerRef:
                                                                    cardRef,
                                                                    draggableProps,
                                                                    dragHandleProps,
                                                                } = provided; */}

                                                    <>
                                                        <Accordion.Header>
                                                            <span
                                                                style={{
                                                                    fontSize:
                                                                        '16pt',
                                                                }}
                                                            >
                                                                {cardTitleField
                                                                    ? kanbanLists[0]
                                                                          ?.cards[
                                                                          index
                                                                      ]?.[
                                                                          cardTitleField
                                                                      ]
                                                                    : `${cardType} ${
                                                                          index +
                                                                          1
                                                                      }`}{' '}
                                                            </span>
                                                        </Accordion.Header>
                                                        <Accordion.Body>
                                                            <KanbanCard
                                                                initialData={
                                                                    kanbanLists[0]
                                                                        ?.cards[
                                                                        index
                                                                    ]
                                                                }
                                                                fontScale={
                                                                    fontScale
                                                                }
                                                                hiddenFields={
                                                                    hiddenFields
                                                                }
                                                                cardType={
                                                                    cardType
                                                                }
                                                                labelColor={
                                                                    labelColor
                                                                }
                                                                attributeForm={
                                                                    attributeForm
                                                                }
                                                                {...card}
                                                                // cardRef={
                                                                //     cardRef
                                                                // }
                                                                // style={getCardStyle(
                                                                //     draggableProps.style,
                                                                //     snapshot
                                                                // )}
                                                                // extraProps={{
                                                                //     ...draggableProps,
                                                                //     ...dragHandleProps,
                                                                // }}
                                                                onDelete={() =>
                                                                    handleCardsDelete(
                                                                        [
                                                                            {
                                                                                listId,
                                                                                cardId,
                                                                            },
                                                                        ]
                                                                    )
                                                                }
                                                                onEdit={() =>
                                                                    setCardToEdit(
                                                                        {
                                                                            show: true,
                                                                            cardId,
                                                                            index,
                                                                            listId,
                                                                        }
                                                                    )
                                                                }
                                                                onCompChange={(
                                                                    id,
                                                                    value
                                                                ) =>
                                                                    handleCardChange(
                                                                        {
                                                                            listId,
                                                                            cardId,
                                                                            value,
                                                                        }
                                                                    )
                                                                }
                                                            />
                                                        </Accordion.Body>
                                                    </>

                                                    {/* }}
                                                        </Draggable> */}
                                                </Accordion.Item>
                                            );
                                        })}
                                </Accordion>

                                {/* {placeholder} */}
                                <div className="d-flex justify-content-center">
                                    <Button
                                        variant="outline-gray-500"
                                        onClick={() =>
                                            toggleCreateCardModal({
                                                listId,
                                                cardIndex: cards.length,
                                            })
                                        }
                                        disabled={
                                            totalSections !== undefined &&
                                            cards.length >= totalSections
                                        }
                                        className="d-inline-flex align-items-center justify-content-center dashed-outline new-card w-50"
                                        style={{
                                            minWidth: '100px',
                                            fontSize:
                                                fontScale !== undefined
                                                    ? `${
                                                          16 + fontScale * 1.5
                                                      }px`
                                                    : '16px',
                                        }}
                                    >
                                        <PlusIcon className="icon icon-xs me-2" />{' '}
                                        {cards?.length
                                            ? `Add another ${lCardType}`
                                            : `Add a new ${lCardType}`}
                                    </Button>
                                </div>
                            </KanbanList>
                        );
                        //     }
                        //             }
                        //             </Droppable>
                        //         );
                        //     })
                    })}
                    {/* </DragDropContext> */}
                </Row>
            </Container>
        </>
    );
};

DynamicFieldsKanbanWidget.defaultProps = {
    cardType: 'Attribute',
    confirmButtonLabel: 'Next',
};
